export const isElementOverflowed = (element: HTMLElement | Element): boolean => {
	return element.clientWidth < element.scrollWidth || element.clientHeight < element.scrollHeight;
};
